"use client";
import { jsx as r, jsxs as x } from "react/jsx-runtime";
import { getCSSValue as X } from "./utils/get-css-value.js";
import b from "clsx";
import { forwardRef as V, useRef as Q, useState as Z, useMemo as G, useEffect as I } from "react";
import "./components/forms/error-alert/error-alert.js";
import "./components/forms/form-checkbox/form-checkbox-input.js";
import "./components/forms/form-calendar/form-calendar.js";
import "./components/forms/form-input/form-input.js";
import { FormItem as z } from "./components/forms/form-item/form-item.js";
import { Icon as R } from "./components/icon/icon.js";
import "./components/forms/form-radio/form-radio-input.js";
import "./components/forms/form-textarea/form-textarea.js";
import "./components/forms/number-stepper/number-stepper.js";
import "./components/forms/stepper/stepper.js";
import { useFieldIds as Y } from "./components/forms/hooks/useFieldIds.js";
import { a as rt, k as it, b as W } from "./virginmediao2-momentum-icons-icons-fas-CfzopcU1.js";
import './assets/uncontrolled.css';const h = {
  "form-list": "_form-list_1hm87_1",
  "form-list--error": "_form-list--error_1hm87_16",
  "form-list--disabled": "_form-list--disabled_1hm87_20",
  "form-list__item": "_form-list__item_1hm87_25",
  "form-list__container": "_form-list__container_1hm87_30",
  "form-list__navigations": "_form-list__navigations_1hm87_46",
  "form-list__navigation": "_form-list__navigation_1hm87_46",
  "form-list__item--selected": "_form-list__item--selected_1hm87_101",
  "form-list__item-state": "_form-list__item-state_1hm87_121",
  "form-list__hidden-input": "_form-list__hidden-input_1hm87_159"
}, lt = V(
  ({
    id: S,
    name: $,
    options: _ = [],
    dataTestId: w,
    disabled: l = !1,
    required: u = !1,
    hasDescription: E = !1,
    label: v,
    description: N,
    autoFocus: C,
    error: F,
    hideLabels: M,
    marginBottom: e,
    onChange: c,
    value: y,
    defaultValue: U,
    height: p = "",
    className: O = "",
    style: q = {},
    ...m
  }, d) => {
    const a = Q(null), f = !!F, s = Y({
      id: S,
      isError: !!f,
      hasDescription: E
    }), [g, D] = Z(
      U ?? y ?? void 0
    ), A = G(() => _.findIndex((t) => t.value === g), [_, g]), K = Q(Math.max(A, 0));
    I(() => {
      g && (K.current = _.findIndex(
        (t) => t.value === g
      ));
    }, [_, g]), I(() => {
      var n;
      const t = (n = a.current) == null ? void 0 : n.querySelector("input");
      t && D(t.value);
    }, [a]), I(() => {
      var t;
      if (C) {
        const n = (t = a.current) == null ? void 0 : t.querySelector(
          '[role="option"][tabindex="0"]'
        );
        n == null || n.focus();
      }
    }, [C]);
    const P = (t) => {
      var k;
      if (l) return;
      const n = (k = a.current) == null ? void 0 : k.querySelector(
        `[role="option"][data-idx="${t}"]`
      );
      n == null || n.focus(), K.current = t;
    }, H = (t) => {
      var L, J;
      if (l) return;
      const n = _[t], k = (n == null ? void 0 : n.value) ?? "", j = (L = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        "value"
      )) == null ? void 0 : L.set, B = (J = a.current) == null ? void 0 : J.querySelector("input");
      if (j && B) {
        j.call(B, k);
        const nt = new Event("change", { bubbles: !0 });
        B.dispatchEvent(nt);
      }
    }, T = (t) => {
      if (t.preventDefault(), l) return;
      const n = Math.max(0, A - 1);
      P(n), H(n);
    }, tt = (t) => {
      if (t.preventDefault(), l) return;
      const n = Math.min(_.length - 1, A + 1);
      P(n), H(n);
    }, et = (t) => {
      const n = t.target.value ?? void 0;
      D(n), c == null || c(t);
    }, ot = (t) => {
      if ([
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "Enter",
        " "
      ].includes(t.key)) {
        if (t.preventDefault(), l) return;
        t.key === "ArrowUp" ? P(Math.max(0, K.current - 1)) : t.key === "ArrowDown" ? P(Math.min(_.length - 1, K.current + 1)) : t.key === "Home" ? P(0) : t.key === "End" ? P(_.length - 1) : (t.key === " " || t.key === "Enter") && H(K.current);
      }
    };
    return /* @__PURE__ */ r(
      z,
      {
        fieldIds: s,
        label: v,
        error: F,
        description: N,
        hideLabels: M,
        marginBottom: e,
        children: /* @__PURE__ */ x(
          "div",
          {
            ref: a,
            className: b(
              h["form-list"],
              {
                [h["form-list--disabled"]]: l,
                [h["form-list--error"]]: f
              },
              O
            ),
            "data-testid": `form-list--${s.id}`,
            style: {
              ...p && { "--height": p },
              ...q
            },
            ...m,
            children: [
              /* @__PURE__ */ r(
                "input",
                {
                  ref: d,
                  type: "text",
                  name: $,
                  value: g ?? "",
                  onChange: et,
                  className: h["form-list__hidden-input"],
                  required: u,
                  "aria-hidden": "true",
                  tabIndex: -1
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  id: s.id,
                  role: "listbox",
                  "aria-labelledby": s.labelId,
                  "aria-describedby": s.describedBy,
                  "aria-invalid": f ? "true" : void 0,
                  "aria-disabled": l ? "true" : void 0,
                  "aria-required": u ? "true" : void 0,
                  className: h["form-list__container"],
                  "data-testid": w ?? `form-list-field--${s.id}`,
                  children: _.map(({ value: t, label: n }, k) => {
                    const j = t.toString() === (g == null ? void 0 : g.toString());
                    let B = -1;
                    return l ? B = void 0 : K.current === k && (B = 0), /* @__PURE__ */ x(
                      "div",
                      {
                        role: "option",
                        className: b(h["form-list__item"], {
                          [h["form-list__item--selected"]]: j
                        }),
                        "aria-selected": j,
                        tabIndex: B,
                        "data-idx": k,
                        "data-value": t.toString(),
                        "data-testid": w ? `${w}_${t}` : `form-list-field--${s.id}_${t}`,
                        onClick: () => H(k),
                        onKeyDown: (L) => ot(L),
                        children: [
                          /* @__PURE__ */ r("div", { className: h["form-list__item-state"], children: j && /* @__PURE__ */ r(R, { icon: rt, size: "sm", color: "success" }) }),
                          /* @__PURE__ */ r("div", { className: h["form-list__item-content"], children: n })
                        ]
                      },
                      `option_${k}`
                    );
                  })
                }
              ),
              /* @__PURE__ */ x("div", { className: h["form-list__navigations"], children: [
                /* @__PURE__ */ r(
                  "button",
                  {
                    className: h["form-list__navigation"],
                    "aria-label": "Select Previous Item",
                    "aria-controls": s.id,
                    disabled: l || A === 0,
                    onClick: (t) => T(t),
                    children: /* @__PURE__ */ r(R, { icon: it })
                  }
                ),
                /* @__PURE__ */ r(
                  "button",
                  {
                    className: h["form-list__navigation"],
                    "aria-label": "Select Next Item",
                    "aria-controls": s.id,
                    disabled: l || A === _.length - 1,
                    onClick: (t) => tt(t),
                    children: /* @__PURE__ */ r(R, { icon: W })
                  }
                )
              ] })
            ]
          }
        )
      }
    );
  }
);
lt.displayName = "FormList";
const i = {
  "form-input": "_form-input_1osie_1",
  "form-input--text-area": "_form-input--text-area_1osie_26",
  "form-input__control": "_form-input__control_1osie_31",
  "form-input--disabled": "_form-input--disabled_1osie_36",
  "form-input--select": "_form-input--select_1osie_41",
  "form-input--readonly": "_form-input--readonly_1osie_46",
  "form-input--error": "_form-input--error_1osie_63",
  "form-input--width-2ch": "_form-input--width-2ch_1osie_68",
  "form-input--width-4ch": "_form-input--width-4ch_1osie_74",
  "form-input__control--affix": "_form-input__control--affix_1osie_135",
  "form-input__control--affix--start--3ch": "_form-input__control--affix--start--3ch_1osie_139",
  "form-input__control--affix--start--2ch": "_form-input__control--affix--start--2ch_1osie_143",
  "form-input__control--affix--start--1ch": "_form-input__control--affix--start--1ch_1osie_147",
  "form-input__control--align-center": "_form-input__control--align-center_1osie_151",
  "form-input__control--select": "_form-input__control--select_1osie_155",
  "form-input__affix": "_form-input__affix_1osie_196",
  "form-input__affix--start": "_form-input__affix--start_1osie_206",
  "form-input__affix--end": "_form-input__affix--end_1osie_210",
  "form-input__suffix": "_form-input__suffix_1osie_218",
  "form-input--width-default": "_form-input--width-default_1osie_240",
  "form-input--width-full-width": "_form-input--width-full-width_1osie_244",
  "form-input--width-fit-content": "_form-input--width-fit-content_1osie_248",
  "form-input--width-max-content": "_form-input--width-max-content_1osie_252",
  "form-input--width-min-content": "_form-input--width-min-content_1osie_256"
}, st = V(
  ({
    id: S,
    name: $,
    dataTestId: _,
    autocomplete: w,
    disabled: l = !1,
    readonly: u = !1,
    required: E = !1,
    affix: v,
    affixWidth: N = "2ch",
    hasDescription: C = !1,
    label: F,
    description: M,
    error: e,
    hideLabels: c,
    marginBottom: y,
    children: U,
    width: p = "default",
    onChange: O,
    ...q
  }, m) => {
    const d = !!e, a = Y({
      id: S,
      isError: !!d,
      hasDescription: C
    });
    return /* @__PURE__ */ r(
      z,
      {
        fieldIds: a,
        label: F,
        error: e,
        description: M,
        hideLabels: c,
        marginBottom: y,
        children: /* @__PURE__ */ x(
          "div",
          {
            className: b(i["form-input"], i["form-input--select"], {
              [i["form-input--disabled"]]: l,
              [i["form-input--readonly"]]: u,
              [i["form-input--error"]]: d,
              [i["form-input--width-default"]]: p === "default",
              [i["form-input--width-full-width"]]: p === "full-width",
              [i["form-input--width-min-content"]]: p === "min-content",
              [i["form-input--width-fit-content"]]: p === "fit-content",
              [i["form-input--width-max-content"]]: p === "max-content"
            }),
            "data-testid": `form-select--${a.id}`,
            children: [
              v && /* @__PURE__ */ r(
                "div",
                {
                  className: b(
                    i["form-input__affix"],
                    i["form-input__affix--start"]
                  ),
                  children: v
                }
              ),
              /* @__PURE__ */ r(
                "select",
                {
                  id: S,
                  name: $,
                  className: b(
                    i["form-input__control"],
                    i["form-input__control--select"],
                    {
                      [i["form-input__control--affix--start--1ch"]]: v && N === "1ch",
                      [i["form-input__control--affix--start--2ch"]]: v && N === "2ch",
                      [i["form-input__control--affix--start--3ch"]]: v && N === "3ch"
                    }
                  ),
                  "aria-describedby": a.describedBy,
                  "aria-invalid": d ? "true" : void 0,
                  "aria-disabled": l ? "true" : void 0,
                  "aria-required": E ? "true" : void 0,
                  "aria-readonly": u ? "true" : void 0,
                  autoComplete: w,
                  disabled: l || u,
                  "data-testid": _ || `form-select-field--${a.id}`,
                  ref: m,
                  onChange: O,
                  required: E,
                  ...q,
                  children: U
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  className: b(
                    i["form-input__affix"],
                    i["form-input__affix--end"]
                  ),
                  children: /* @__PURE__ */ r(R, { icon: W, size: "md" })
                }
              )
            ]
          }
        )
      }
    );
  }
);
st.displayName = "FormSelect";
const o = {
  "segmented-control": "_segmented-control_o1b42_1",
  "segmented-control--has-third-segment": "_segmented-control--has-third-segment_o1b42_33",
  "segmented-control--indicator-false": "_segmented-control--indicator-false_o1b42_42",
  "segmented-control--secondary": "_segmented-control--secondary_o1b42_47",
  "segmented-control--tertiary": "_segmented-control--tertiary_o1b42_48",
  "segmented-control--indicator": "_segmented-control--indicator_o1b42_42",
  "segmented-control--indicator-true": "_segmented-control--indicator-true_o1b42_77",
  "segmented-control--indicator-maybe": "_segmented-control--indicator-maybe_o1b42_89",
  "segmented-control__option": "_segmented-control__option_o1b42_100",
  "segmented-control__option--selected": "_segmented-control__option--selected_o1b42_122",
  "segmented-control__option--true": "_segmented-control__option--true_o1b42_126",
  "segmented-control__option--false": "_segmented-control__option--false_o1b42_130",
  "segmented-control__option--maybe": "_segmented-control__option--maybe_o1b42_138",
  "segmented-control__option-control": "_segmented-control__option-control_o1b42_142"
}, _t = V(
  ({
    id: S,
    name: $,
    hasDescription: _,
    label: w,
    description: l,
    error: u,
    hideLabels: E = !1,
    marginBottom: v,
    onChange: N = () => {
    },
    falseLabel: C = "No",
    trueLabel: F = "Yes",
    variant: M = "primary",
    dataTestId: e = "segmented-control",
    selected: c = !0,
    rounded: y,
    style: U = {},
    className: p,
    ...O
  }, q) => {
    const [m, d] = Z(
      c
    ), a = !!u, f = Y({
      id: S,
      isError: !!a,
      hasDescription: _
    }), s = (D, A) => {
      d(A), N(D);
    }, g = G(
      () => y ? X(y, "border-radius") : void 0,
      [y]
    );
    return /* @__PURE__ */ r(
      z,
      {
        fieldIds: f,
        label: w,
        error: u,
        description: l,
        hideLabels: E,
        marginBottom: v,
        children: /* @__PURE__ */ x(
          "div",
          {
            className: b(
              o["segmented-control"],
              o[`segmented-control--${M}`],
              {
                [o["segmented-control--indicator"]]: m !== null,
                [o["segmented-control--indicator-true"]]: m,
                [o["segmented-control--indicator-false"]]: !m
              },
              p
            ),
            role: "radiogroup",
            "aria-labelledby": f.labelId,
            "data-testid": e ? `${e}-radio-group` : `segment-control-radio-group-${f.id}`,
            "aria-describedby": f.describedBy,
            "aria-invalid": a ? "true" : void 0,
            ref: q,
            style: {
              "--_segmented-control-radius-outer": g,
              "--_segmented-control-radius-inner": g,
              ...U
            },
            ...O,
            children: [
              /* @__PURE__ */ x(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--true"],
                    {
                      [o["segmented-control__option--selected"]]: m && m !== null
                    }
                  ),
                  "data-testid": e ? `${e}-true` : `segment-control-label-true-${f.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: $,
                        value: "true",
                        checked: m === !0,
                        onChange: (D) => s(D, !0),
                        "data-testid": e ? `${e}-input-true` : `segment-control-input-true-${f.id}`
                      }
                    ),
                    F
                  ]
                }
              ),
              /* @__PURE__ */ x(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--false"],
                    {
                      [o["segmented-control__option--selected"]]: !m && m !== null
                    }
                  ),
                  "data-testid": e ? `${e}-false` : `segment-control-label-false-${f.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: $,
                        value: "false",
                        checked: m === !1,
                        onChange: (D) => s(D, !1),
                        "data-testid": e ? `${e}-input-false` : `segment-control-input-false-${f.id}`
                      }
                    ),
                    C
                  ]
                }
              )
            ]
          }
        )
      }
    );
  }
);
_t.displayName = "Controlled";
const ct = V(
  ({
    id: S,
    name: $,
    hasDescription: _,
    label: w,
    description: l,
    error: u,
    hideLabels: E = !1,
    marginBottom: v,
    onChange: N = () => {
    },
    falseLabel: C = "No",
    trueLabel: F = "Yes",
    variant: M = "primary",
    dataTestId: e = "segmented-control",
    selected: c = !0,
    rounded: y,
    style: U = {},
    className: p,
    ...O
  }, q) => {
    const m = !!u, d = Y({
      id: S,
      isError: !!m,
      hasDescription: _
    }), a = (s) => {
      N(s);
    }, f = G(
      () => y ? X(y, "border-radius") : void 0,
      [y]
    );
    return /* @__PURE__ */ r(
      z,
      {
        fieldIds: d,
        label: w,
        error: u,
        description: l,
        hideLabels: E,
        marginBottom: v,
        children: /* @__PURE__ */ x(
          "div",
          {
            className: b(
              o["segmented-control"],
              o[`segmented-control--${M}`],
              {
                [o["segmented-control--indicator"]]: c !== null,
                [o["segmented-control--indicator-true"]]: c,
                [o["segmented-control--indicator-false"]]: !c
              },
              p
            ),
            role: "radiogroup",
            "aria-labelledby": d.labelId,
            "data-testid": e ? `${e}-radio-group` : `segment-control-radio-group-${d.id}`,
            "aria-describedby": d.describedBy,
            "aria-invalid": m ? "true" : void 0,
            ref: q,
            style: {
              "--_segmented-control-radius-outer": f,
              "--_segmented-control-radius-inner": f,
              ...U
            },
            ...O,
            children: [
              /* @__PURE__ */ x(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--true"],
                    {
                      [o["segmented-control__option--selected"]]: c && c !== null
                    }
                  ),
                  "data-testid": e ? `${e}-true` : `segment-control-label-true-${d.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: $,
                        value: "true",
                        checked: c === !0,
                        onChange: (s) => a(s),
                        "data-testid": e ? `${e}-input-true` : `segment-control-input-true-${d.id}`
                      }
                    ),
                    F
                  ]
                }
              ),
              /* @__PURE__ */ x(
                "label",
                {
                  className: b(
                    o["segmented-control__option"],
                    o["segmented-control__option--false"],
                    {
                      [o["segmented-control__option--selected"]]: !c && c !== null
                    }
                  ),
                  "data-testid": e ? `${e}-false` : `segment-control-label-false-${d.id}`,
                  children: [
                    /* @__PURE__ */ r(
                      "input",
                      {
                        type: "radio",
                        className: o["segmented-control__option-control"],
                        name: $,
                        value: "false",
                        checked: c === !1,
                        onChange: (s) => a(s),
                        "data-testid": e ? `${e}-input-false` : `segment-control-input-false-${d.id}`
                      }
                    ),
                    C
                  ]
                }
              )
            ]
          }
        )
      }
    );
  }
);
ct.displayName = "Uncontrolled";
export {
  _t as C,
  lt as F,
  ct as U,
  st as a
};
